import { Record } from 'immutable';
import { first } from 'lodash';
import { Base } from './base';
import Image from './image';
import Vendor from './vendor';

class User extends Base(Record({
  id: null,
  first_name: '',
  last_name: '',
  email: '',
  password: '',
  postal_code: '',
  proxies: [Image]
})) {
  $get(id) {
    if (!id) id = this.id;

    const v = new Vendor();

    return this.api.get({
      id: id,
      resource: 'users'
    })
    .then(res => Promise.all(
      [res].concat(Promise.all(
        this.proxies.map(p => this.$proxy(new p({ user_id: res.data.id }), res.data.id, 'users'))
      ))
    ))
    .then(res => Promise.all([
      v.$get(id),
      first(res).data
    ]));
  }

  $index(search) {
    return this.api.get({
      resource: 'users?filter[email]=' + encodeURIComponent(search)
    });
  }

  $update() {
    return this.api.patch({
      id: this.id,
      resource: 'users'
    }, this.api.payload('users', this));
  }

  $following() {
    return this.api.get({
      resource: 'users/' + this.id + '/relationships/following'
    });
  }

  $vouchers() {
    if (!this.id) return Promise.resolve(null);

    return this.api.get({
      resource: 'vouchers?filter[user_id]=' + this.id
    });
  }

  profilePicUrl(transformations) {
    const vendor = new Vendor({
      user_id: this.id
    });
    return vendor.profilePicUrl(transformations, 'users');
  }
}

export default User;



// WEBPACK FOOTER //
// ./src/records/user.js